// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_2.cjs
/* eslint-disable */
const mission = {
  "id": "humans_2",
  "campaignFactionId": "humans",
  "order": 2,
  "title": "Стены Верцелл",
  "shortTitle": "Миссия II",
  "description": "Выдержи первый штурм орков и верни Виктимулы",
  "finalRound": 11,
  "reward": {
    "type": "chest",
    "chestId": "chest_random_default"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Гхарзуг",
      "color": "red",
      "factionId": "orcs",
      "selectedSkin": "orcs_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-9,-6": "sea",
      "-9,-5": "sea",
      "-9,-4": "sea",
      "-10,-3": "sea",
      "-10,-2": "sea",
      "-10,-1": "sea",
      "-10,0": "sea",
      "-11,1": "sea",
      "-11,2": "sea",
      "-11,3": "sea",
      "-10,3": "sea",
      "-10,4": "sea",
      "-10,5": "sea",
      "-10,6": "sea",
      "-9,6": "sea",
      "-9,7": "sea",
      "-9,8": "sea",
      "-8,8": "sea",
      "-8,9": "sea",
      "-7,9": "sea",
      "-7,10": "sea",
      "-6,10": "sea",
      "-6,11": "sea",
      "-5,11": "sea",
      "-5,12": "sea",
      "-4,12": "sea",
      "-4,-9": "mountain",
      "-4,-8": "mountain",
      "-4,-7": "mountain",
      "-3,-10": "mountain",
      "-3,-9": "mountain",
      "-3,-8": "mountain",
      "-3,-7": "mountain",
      "-2,-11": "mountain",
      "-2,-10": "mountain",
      "-2,-9": "mountain",
      "-2,-8": "mountain",
      "-2,-7": "mountain",
      "-1,-11": "mountain",
      "-1,-10": "mountain",
      "-1,-9": "mountain",
      "-1,-8": "mountain",
      "0,-11": "mountain",
      "0,-10": "mountain",
      "0,-9": "mountain",
      "2,-10": "mountain",
      "2,-9": "mountain",
      "2,-8": "mountain",
      "3,-11": "mountain",
      "3,-10": "mountain",
      "3,-9": "mountain",
      "3,-8": "mountain",
      "4,-12": "mountain",
      "4,-11": "mountain",
      "4,-10": "mountain",
      "4,-9": "mountain",
      "4,-8": "mountain",
      "5,-12": "mountain",
      "5,-11": "mountain",
      "5,-10": "mountain",
      "5,-9": "mountain",
      "6,-12": "mountain",
      "6,-11": "mountain",
      "6,-10": "mountain",
      "8,-9": "mountain",
      "8,-8": "mountain",
      "9,-10": "mountain",
      "9,-9": "mountain",
      "9,-8": "mountain",
      "10,-10": "mountain",
      "10,-9": "mountain",
      "-7,11": "mountain",
      "-6,9": "mountain",
      "-5,9": "mountain",
      "-5,10": "mountain",
      "0,9": "mountain",
      "0,10": "mountain",
      "0,11": "mountain",
      "1,8": "mountain",
      "1,9": "mountain",
      "1,10": "mountain",
      "1,11": "mountain",
      "2,7": "mountain",
      "2,8": "mountain",
      "2,9": "mountain",
      "2,10": "mountain",
      "2,11": "mountain",
      "3,7": "mountain",
      "3,8": "mountain",
      "3,9": "mountain",
      "3,10": "mountain",
      "4,7": "mountain",
      "4,8": "mountain",
      "4,9": "mountain",
      "-7,1": "flag_blue",
      "-8,2": "quarter",
      "-6,0": "quarter",
      "-6,1": "quarter",
      "-7,0": "quarter",
      "-7,2": "farm",
      "-8,0": "farm",
      "-8,1": "barracks",
      "-5,1": "road",
      "-4,1": "road",
      "-3,1": "road",
      "-2,0": "road",
      "-1,0": "road",
      "0,0": "mine",
      "1,-1": "super_mine",
      "0,-1": "ruins",
      "2,0": "ruins",
      "2,-2": "ruins",
      "-1,-1": "mountain",
      "-1,1": "mountain",
      "2,-1": "road",
      "3,-1": "road",
      "1,1": "farm",
      "5,0": "flag_red",
      "4,1": "quarter",
      "5,-1": "quarter",
      "6,-1": "road",
      "5,1": "farm",
      "4,-1": "farm",
      "6,0": "farm",
      "4,0": "barracks",
      "9,-4": "road",
      "10,-5": "road",
      "11,-5": "road",
      "12,-6": "road",
      "7,-2": "road",
      "8,-3": "road",
      "10,-6": "mountain",
      "11,-4": "mountain",
      "-14,0": "sea",
      "-14,3": "sea",
      "-14,6": "sea",
      "-14,9": "sea",
      "-14,12": "sea",
      "-13,-1": "sea",
      "-12,14": "sea",
      "-10,-4": "sea",
      "-9,14": "sea",
      "-7,-7": "sea",
      "-6,14": "sea",
      "-4,-10": "sea",
      "-3,14": "sea",
      "-1,-13": "sea",
      "0,14": "sea",
      "2,-14": "sea",
      "3,11": "sea",
      "5,-14": "sea",
      "6,8": "sea",
      "8,-14": "sea",
      "9,5": "sea",
      "11,-14": "sea",
      "12,2": "sea",
      "14,-14": "sea",
      "14,-11": "sea",
      "14,-8": "sea",
      "14,-5": "sea",
      "14,-2": "sea",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "8,8": "sea",
      "9,-16": "sea",
      "9,7": "sea",
      "10,-16": "sea",
      "10,6": "sea",
      "11,-16": "sea",
      "11,5": "sea",
      "12,-16": "sea",
      "12,4": "sea",
      "13,-16": "sea",
      "13,3": "sea",
      "14,-16": "sea",
      "14,2": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_blue_0_-6_1",
        "hexKey": "-6,1",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_blue_1_-7_0",
        "hexKey": "-7,0",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_red_2_6_0",
        "hexKey": "6,0",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_red_3_5_-1",
        "hexKey": "5,-1",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_red_4_-4_1",
        "hexKey": "-4,1",
        "ownerId": "player_id_red",
        "type": "unit_d20",
        "size": 16,
        "maxSize": 20
      },
      {
        "id": "u_red_5_-4_0",
        "hexKey": "-4,0",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_6_-4_-2",
        "hexKey": "-4,-2",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 7,
        "maxSize": 10
      },
      {
        "id": "orc_ram_leader",
        "hexKey": "-3,1",
        "ownerId": "player_id_red",
        "type": "unit_d12",
        "size": 12,
        "maxSize": 12
      }
    ],
    "specialBuildings": {
      "-6,1": "fortress",
      "6,1": "warehouse",
      "4,-2": "warehouse"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "barbarism",
      "name": "Варварство",
      "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
      "implemented": true
    },
    {
      "id": "totalitarianism",
      "name": "Тоталитаризм",
      "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
      "implemented": true
    },
    {
      "id": "servarianism",
      "name": "Серваризм",
      "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
      "implemented": true
    },
    {
      "id": "fortificationism",
      "name": "Фортификационизм",
      "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
      "implemented": true
    },
    {
      "id": "ecoanarchism",
      "name": "Экоанархизм",
      "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
      "implemented": true
    },
    {
      "id": "theocracy",
      "name": "Теократия",
      "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
      "implemented": true
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Ты пишешь, что боишься терять людей. Хорошо, что пишешь это мне, а не говоришь им. Запомни: солдат — это расход войны, как хлеб и железо. Командир, который жалеет расход, проигрывает войну и теряет всех. Считай — и не оглядывайся. — М. Аврелий Скавр, сыну»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_hold_assault",
        "type": "survive_rounds",
        "params": {
          "rounds": 5
        },
        "text": "Выдержи штурм",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_ram_leader",
        "type": "destroy_unit",
        "params": {
          "unitId": "orc_ram_leader"
        },
        "text": "Убей вожака штурма",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_super_mine",
        "type": "capture_key_point",
        "params": {
          "hexKey": "1,-1"
        },
        "text": "Присоедини великий рудник Бессы: заложи рядом новый центральный квартал",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_take_victimulae",
        "type": "capture_city",
        "params": {
          "centralHexKey": "5,0"
        },
        "text": "Выбей орков из Виктимул",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_scouts_report",
        "type": "survive_rounds",
        "params": {
          "rounds": 11
        },
        "text": "Дождись доклада дозорных",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_6_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h2_lose_vercellae",
        "type": "lose_city",
        "params": {
          "centralHexKey": "-7,1"
        },
        "text": "Не потеряй Верцеллы",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_7_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_red",
          "hexKey": "5,0"
        }
      }
    },
    {
      "id": "entry_8_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_red",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_9_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 0,
          "currentPlayerId": "player_id_red",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_10_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, у ворот человек! Один, пеший… Легат — это ЦЕНТУРИОН. Атилий это!",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_dozorny_wall.png"
      }
    },
    {
      "id": "e_11_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Центурион Секст Атилий. Заслон задачу выполнил. Противник задержан у отвалов до рассвета. Потери заслона… …тридцать девять. Разреши встать в строй, легат.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_atilius_broken.png"
      }
    },
    {
      "id": "e_12_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Центурион… Секст. Я…",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_doubt.png"
      }
    },
    {
      "id": "e_13_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не смей извиняться. Извинишься — украдёшь у него счёт. Этот счёт — всё, что у него от них осталось.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_grim.png"
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Встань в строй, центурион. Левый фас, у ворот. Самый тяжёлый.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_doubt.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Так точно. Где мои люди, легат?.. Ладно. Левый фас так левый фас.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_atilius_broken.png"
      }
    },
    {
      "id": "entry_16_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_20_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_21_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_22_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_23_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_24_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_25_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_26_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "-5,1"
        }
      }
    },
    {
      "id": "entry_27_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "-4,1",
          "toHexKey": "-5,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_28_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_-4_0",
          "unitType": "unit_d10",
          "newHexKey": "-5,0"
        }
      }
    },
    {
      "id": "entry_29_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_-4_0",
          "fromHexKey": "-4,0",
          "toHexKey": "-5,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_30_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_-4_-2",
          "unitType": "unit_d10",
          "newHexKey": "-5,-1"
        }
      }
    },
    {
      "id": "entry_31_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_-4_-2",
          "fromHexKey": "-4,-2",
          "toHexKey": "-5,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_32_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_33_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_39_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_40_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_41_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_42_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_43_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_44_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_45_replica",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин. Смотри, как они идут. Видишь — падают, и по упавшим идут следующие? Наши на востоке год учились это понимать. Они не считают своих, господин. Совсем. Их нельзя испугать потерями — им нельзя сделать «слишком дорого».",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m2_ilva_calm.png"
      }
    },
    {
      "id": "e_46_replica",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Тогда чем их можно остановить, женщина? Ты видела — чем?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_stern.png"
      }
    },
    {
      "id": "e_47_replica",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Видела. Один раз. Вожака убей. Не потому что заплачут — они не плачут. Просто без вожака они… спорят. Долго. Громко. Иногда — до утра. Утром можно уже не бояться: они дерутся между собой.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m2_ilva_calm.png"
      }
    },
    {
      "id": "e_48_replica",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Дельная женщина. Легат, слышал? Вон он, их спорщик, — под тараном, шире всех орёт. Разреши, я с ребятами поднесу ему предмет для дискуссии.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_war.png"
      }
    },
    {
      "id": "entry_49_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_50_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_51_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_52_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_53_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_-4_-2",
          "unitType": "unit_d10",
          "newHexKey": "-6,-1"
        }
      }
    },
    {
      "id": "entry_54_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_-4_-2",
          "fromHexKey": "-5,-1",
          "toHexKey": "-6,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_55_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_56_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_62_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_63_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_64_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_65_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_66_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_67_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_68_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_69_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_70_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_71_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_72_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_73_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_74_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_75_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_76_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_77_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_78_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_79_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_80_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_81_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_82_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_83_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_84_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_85_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_86_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "1,-1"
        }
      }
    },
    {
      "id": "entry_87_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "-3,1",
          "toHexKey": "1,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_88_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "-3,1"
        }
      }
    },
    {
      "id": "entry_89_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "-5,1",
          "toHexKey": "-3,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_90_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_91_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_92_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_93_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_94_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "orc_ram_leader",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_95_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_96_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_97_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_98_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_99_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "orc_ram_leader",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_100_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_101_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_102_replica",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Требоний. Кони — лучшие, подорожная — моя, печать — отцовская, её в Риме знают. Донесение отдашь лично претору, а лучше — в сенатскую канцелярию, и смотри кому-нибудь из Метеллов в глаза, когда будут читать.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_stern.png"
      }
    },
    {
      "id": "e_103_replica",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Так точно, легат!.. Легат. Разреши вопрос. Там написано… про НИХ. Про то, какие они. А если мне не поверят? Я бы сам не поверил, легат.",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_trebonius.png"
      }
    },
    {
      "id": "e_104_replica",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Скажи: Аврелий Скавр видел своими глазами. Этого хватит.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_stern.png"
      }
    },
    {
      "id": "e_105_replica",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не хватит, мальчик. Я тридцать лет вожу в Рим плохие новости. Хорошим верят сразу, плохим — когда те сами приходят в гости… Ну да пусть скачет. Пусть хоть дороги посмотрит.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_grim.png"
      }
    },
    {
      "id": "entry_106_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_107_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_108_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_109_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_110_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "4,-1"
        }
      }
    },
    {
      "id": "entry_111_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "1,-1",
          "toHexKey": "4,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_112_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "-1,0"
        }
      }
    },
    {
      "id": "entry_113_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "-3,1",
          "toHexKey": "-1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_114_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_115_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_116_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_117_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_118_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "-1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_119_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "orc_ram_leader",
          "unitHexKey": "4,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_120_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_121_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_122_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_123_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "-1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_124_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_125_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_126_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_127_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_128_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "4,0",
          "unitType": "unit_d10",
          "factionId": "orcs",
          "price": 5,
          "unitId": "rec_red_6_4_0"
        }
      }
    },
    {
      "id": "entry_129_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "4,0",
          "price": 5,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_130_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_131_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_132_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "unitType": "unit_d10",
          "newHexKey": "6,-1"
        }
      }
    },
    {
      "id": "entry_133_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "fromHexKey": "4,0",
          "toHexKey": "6,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_134_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "4,0"
        }
      }
    },
    {
      "id": "entry_135_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "4,-1",
          "toHexKey": "4,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_136_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "1,-1"
        }
      }
    },
    {
      "id": "entry_137_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "-1,0",
          "toHexKey": "1,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_138_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_139_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_140_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_141_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_142_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_143_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "orc_ram_leader",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_144_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_145_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_146_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_147_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_148_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_149_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_150_replica",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Хутора видел, легат? Стены ломаные — а двери целые, рядом. Им не нужно ВНУТРЬ. Им нужно ЧТОБЫ НЕ БЫЛО. Теперь я знаю, почему мои сорок не отступили. От такого не отступают к своим. От такого своих закрывают.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_atilius_broken.png"
      }
    },
    {
      "id": "e_151_replica",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ну вот. Заговорил. Значит, жить будет… Ты, главное, ему сейчас ничего не отвечай, легат. Он не тебе говорил. Он себе объяснял.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_grim.png"
      }
    },
    {
      "id": "entry_152_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_153_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_154_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_155_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_156_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "3,-1"
        }
      }
    },
    {
      "id": "entry_157_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "1,-1",
          "toHexKey": "3,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_158_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_159_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_160_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_161_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_162_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "3,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_163_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "orc_ram_leader",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_164_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_165_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_166_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_167_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_168_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_169_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_170_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_171_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_172_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_173_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_174_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "4,-1"
        }
      }
    },
    {
      "id": "entry_175_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "3,-1",
          "toHexKey": "4,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_176_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_2_6_0",
          "unitType": "unit_d6",
          "newHexKey": "7,-2"
        }
      }
    },
    {
      "id": "entry_177_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_2_6_0",
          "fromHexKey": "6,0",
          "toHexKey": "7,-2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_178_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_179_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_180_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_181_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_182_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "4,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_183_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "orc_ram_leader",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_184_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_185_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "6,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_186_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "7,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_187_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "orc_ram_leader",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_188_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_189_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_190_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_191_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_192_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_193_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_194_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "8,-3"
        }
      }
    },
    {
      "id": "entry_195_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "4,0",
          "toHexKey": "8,-3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_196_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_2_6_0",
          "unitType": "unit_d6",
          "newHexKey": "9,-4"
        }
      }
    },
    {
      "id": "entry_197_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_2_6_0",
          "fromHexKey": "7,-2",
          "toHexKey": "9,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_198_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "unitType": "unit_d10",
          "newHexKey": "7,-2"
        }
      }
    },
    {
      "id": "entry_199_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "fromHexKey": "6,-1",
          "toHexKey": "7,-2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_200_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "unitType": "unit_d10",
          "newHexKey": "7,-1"
        }
      }
    },
    {
      "id": "entry_201_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "fromHexKey": "5,-1",
          "toHexKey": "7,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_202_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "5,-2"
        }
      }
    },
    {
      "id": "entry_203_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "4,-1",
          "toHexKey": "5,-2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_204_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_205_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_206_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_207_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_208_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "5,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_209_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "orc_ram_leader",
          "unitHexKey": "8,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_210_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "7,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_211_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "7,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_212_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_2_6_0",
          "unitHexKey": "9,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_213_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "orc_ram_leader",
          "unitHexKey": "8,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_214_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_215_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_216_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Посёлок чист, легат! Они… они не защищались до конца. Как приказ у них какой — бросили и ушли на северо-восток. Бегом ушли. Мы гнали — не догнать, они бегом БЫСТРЕЕ КОННОГО, легат…",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_dozorny_wall.png"
      }
    },
    {
      "id": "e_217_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Не защищались… Квинт, когда враг бросает крепость — что это значит?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_doubt.png"
      }
    },
    {
      "id": "e_218_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Значит, крепость ему больше не нужна, мальчик. Значит, у него теперь есть… …Легат. Поднимись сюда. Сам поднимись.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_grim.png"
      }
    },
    {
      "id": "e_219_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Это что — зарево? Лес горит?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_lucius_doubt.png"
      }
    },
    {
      "id": "e_220_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Это не зарево. Это костры. Сотня… вторая… третья… Мальчик. То, что мы разбили, — у них это был ДОЗОР. А это — идёт войско.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m2_barba_fires.png"
      }
    },
    {
      "id": "e_221_replica",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вот так это и начинается. Вот ровно так это начиналось у нас.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m2_ilva_grief.png"
      }
    },
    {
      "id": "entry_222_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_223_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_224_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_225_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_226_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "12,-6"
        }
      }
    },
    {
      "id": "entry_227_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "8,-3",
          "toHexKey": "12,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_228_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_2_6_0",
          "unitType": "unit_d6",
          "newHexKey": "11,-5"
        }
      }
    },
    {
      "id": "entry_229_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_2_6_0",
          "fromHexKey": "9,-4",
          "toHexKey": "11,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_230_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "unitType": "unit_d10",
          "newHexKey": "9,-4"
        }
      }
    },
    {
      "id": "entry_231_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "fromHexKey": "7,-2",
          "toHexKey": "9,-4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_232_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "unitType": "unit_d10",
          "newHexKey": "8,-3"
        }
      }
    },
    {
      "id": "entry_233_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "fromHexKey": "7,-1",
          "toHexKey": "8,-3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_234_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "6,-2"
        }
      }
    },
    {
      "id": "entry_235_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "5,-2",
          "toHexKey": "6,-2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_236_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_237_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_238_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_239_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_240_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "6,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_241_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,0",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "8,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_242_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "9,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_243_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,1",
          "unitId": "u_red_4_-4_1",
          "unitHexKey": "6,-2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_244_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "u_red_3_5_-1",
          "unitHexKey": "8,-3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_245_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,-1",
          "unitId": "rec_red_6_4_0",
          "unitHexKey": "9,-4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_246_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_247_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_248_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_249_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_250_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_251_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_252_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_ram_leader",
          "unitType": "unit_d12",
          "newHexKey": "13,-7"
        }
      }
    },
    {
      "id": "entry_253_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_ram_leader",
          "fromHexKey": "12,-6",
          "toHexKey": "13,-7",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_254_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_2_6_0",
          "unitType": "unit_d6",
          "newHexKey": "12,-6"
        }
      }
    },
    {
      "id": "entry_255_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_2_6_0",
          "fromHexKey": "11,-5",
          "toHexKey": "12,-6",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_256_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "unitType": "unit_d10",
          "newHexKey": "11,-5"
        }
      }
    },
    {
      "id": "entry_257_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_6_4_0",
          "fromHexKey": "9,-4",
          "toHexKey": "11,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_258_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "unitType": "unit_d10",
          "newHexKey": "10,-5"
        }
      }
    },
    {
      "id": "entry_259_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_5_-1",
          "fromHexKey": "8,-3",
          "toHexKey": "10,-5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_260_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "unitType": "unit_d20",
          "newHexKey": "8,-3"
        }
      }
    },
    {
      "id": "entry_261_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_-4_1",
          "fromHexKey": "6,-2",
          "toHexKey": "8,-3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_262_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_263_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_264_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_265_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h2_hold_assault",
      "type": "survive_rounds",
      "params": {
        "rounds": 5
      },
      "text": "Выдержи штурм",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h2_ram_leader",
      "type": "destroy_unit",
      "params": {
        "unitId": "orc_ram_leader"
      },
      "text": "Убей вожака штурма",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h2_super_mine",
      "type": "capture_key_point",
      "params": {
        "hexKey": "1,-1"
      },
      "text": "Присоедини великий рудник Бессы: заложи рядом новый центральный квартал",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h2_take_victimulae",
      "type": "capture_city",
      "params": {
        "centralHexKey": "5,0"
      },
      "text": "Выбей орков из Виктимул",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h2_scouts_report",
      "type": "survive_rounds",
      "params": {
        "rounds": 11
      },
      "text": "Дождись доклада дозорных",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h2_lose_vercellae",
      "type": "lose_city",
      "params": {
        "centralHexKey": "-7,1"
      },
      "text": "Не потеряй Верцеллы",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
